import { useQuery } from '@tanstack/react-query';
import { gmbApi } from '@/services/gmbApi';

const getStoredUserId = () => localStorage.getItem('user_id') ?? '';

export function useGmbPerformanceTrends(
  period: 'weekly' | 'monthly' = 'weekly'
) {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'performance-trends', userId, period],
    queryFn: () => gmbApi.getPerformanceTrends(userId, period),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbSearchQueries() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'search-queries', userId],
    queryFn: () => gmbApi.getSearchQueries(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbReputationInsights() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'reputation-insights', userId],
    queryFn: () => gmbApi.getReputationInsights(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbContentPerformance() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'content-performance', userId],
    queryFn: () => gmbApi.getContentPerformance(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbEngagementInsights() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'engagement-insights', userId],
    queryFn: () => gmbApi.getEngagementInsights(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbRecommendations() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'recommendations', userId],
    queryFn: () => gmbApi.getRecommendations(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}

export function useGmbMonthlyAudit() {
  const userId = getStoredUserId();
  return useQuery({
    queryKey: ['gmb', 'optimization', 'monthly-audit', userId],
    queryFn: () => gmbApi.getMonthlyAudit(userId),
    enabled: !!userId,
    staleTime: 5 * 60 * 1000,
  });
}
